import {
  DetailedHTMLProps,
  FunctionComponent,
  InputHTMLAttributes,
  ReactNode,
} from "react";
import styles from "./RadioButton.module.scss";

type RadioButtonProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  label: ReactNode;
  textVal?: string;
  onTextInputChange?: (val: string) => void;
};

const RadioButton: FunctionComponent<RadioButtonProps> = ({
  onChange,
  onTextInputChange,
  id,
  checked,
  disabled,
  label,
  value,
  textVal = "",
  className = "",
}) => {
  return (
    <div className={`${styles.radioButton} ${className}`}>
      <input
        type="radio"
        className={styles.radioInput}
        id={id}
        onChange={onChange}
        value={value}
        checked={checked}
        disabled={disabled}
      />
      <span className={styles.customRadio} />
      <label className={styles.radioLabel} htmlFor={id}>
        {label}
      </label>
      {onTextInputChange && (
        <input
          className={styles.otherInput}
          onChange={(e) => onTextInputChange(e.target.value)}
          value={textVal}
        />
      )}
    </div>
  );
};

export default RadioButton;
